export * from './post-datei-art.component';
export * from './post-datei-art.component.module';